import { AuditableResponse } from "../common/AuditableResponse"

export class BuildTypeDetails extends AuditableResponse {
  id: number
  cartridgeRequired: boolean
  name: string

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, cartridgeRequired?: boolean, name?: string, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.cartridgeRequired = cartridgeRequired ?? false
    this.name = name ?? ''
  }
}
